<header>
  <div class="container-header">
    <div class="logo" routerLink="">
      <img src="/assets/img/logo-Ubilaw.svg" alt="UBILAW" />
    </div>

    <div class="header-right">
      <app-main-nav></app-main-nav>

      <a
        href="https://app.ubilaw.com"
        class="btn btn-primary btn-connect"
        target="_blank"
      >
        Connexion
      </a>

      <app-main-nav-mobile></app-main-nav-mobile>
    </div>
  </div>
</header>
